import React from "react";
import { Box, Typography } from "@mui/material";
import { ReactComponent as WebcamIcon } from "../../resources/images/svg/home/webcamWhite.svg";

import zoomIcon from "../../resources/images/png/home/zoomIcon.png";

export const useDatePlace = (date) => {
  return React.useMemo(() => {
    if (!date) return null;
    return date.lieux !== "" ? JSON.parse(date.lieux) : {};
  }, [date]);
}

export const isPlaceInVisio = (place) => {
  return place.visio === true || place.visio === "true";
}

const EventPlace = ({ date, ...props }) => {
  const place = useDatePlace(date);

  const placeDetail = React.useMemo(() => {
    if (!place) return "Lieu à définir";
    if (isPlaceInVisio(place))
      return (
        <>
         {/* Via {" "}
          <img src={zoomIcon} alt={"zoom"} width={55}/>*/}
          Uniquement en visio
        </>
      );
    else return `${place.adresse}, ${place.cp} ${place.ville}`;
  }, [place]);

  return (
    <Box
      {...props}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        ...props.sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "55px",
          height: "55px",
          background: "#0D0034",
          borderRadius: "50%",
          marginRight: 2,
        }}
      >
        <WebcamIcon />
      </Box>
      <Typography
        sx={{
          color: (theme) => theme.palette.blackPro,
          fontSize: 18,
          fontWeight: "bold",
        }}
      >
        {placeDetail}
      </Typography>
    </Box>
  );
};

export default EventPlace;
